import React, { createContext, useState, useEffect, useCallback, useContext } from "react";
import WishlistServ from "./service/WishlistServ";
import { message, Modal } from "antd";
import { useNavigate } from "react-router-dom";

export const WishlistContext = createContext();

export const WishlistProvider = ({ children }) => {
    const [wishlist, setWishlist] = useState({ products: [] });
    const [wishlistCount, setWishlistCount] = useState(0);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const fetchWishlist = useCallback(async () => {
        const token = localStorage.getItem("customerToken") || localStorage.getItem("token");
        if (!token || token === "null" || token === "undefined") {
            setWishlist({ products: [] });
            setWishlistCount(0);
            return;
        }

        try {
            setLoading(true);
            const data = await WishlistServ.getWishlist();
            setWishlist(data || { products: [] });
            setWishlistCount(data?.products?.length || 0);
        } catch (error) {
            console.error("❌ Fetch wishlist error:", error);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchWishlist();

        const handleAuthChange = () => {
            console.log("🔄 WishlistContext - Refreshing due to auth change");
            fetchWishlist();
        };

        window.addEventListener("storage", handleAuthChange);
        window.addEventListener("auth-change", handleAuthChange);

        return () => {
            window.removeEventListener("storage", handleAuthChange);
            window.removeEventListener("auth-change", handleAuthChange);
        };
    }, [fetchWishlist]);

    const toggleWishlist = async (productId) => {
        const token = localStorage.getItem("customerToken") || localStorage.getItem("token");
        console.log("🔍 WishlistContext - toggleWishlist check. Token:", token);

        if (!token || token === "null" || token === "undefined") {
            console.log("⚠️ No valid token found, showing modal.");
            Modal.info({
                title: "Authentication required",
                content: "Please log in first to manage your wishlist!",
                onOk: () => {
                    console.log("➡️ Redirecting to login...");
                    navigate("/customer-login");
                },
            });
            return;
        }

        try {
            const data = await WishlistServ.toggleWishlist(productId);
            setWishlist(data);
            setWishlistCount(data?.products?.length || 0);

            const isAdded = data.products.some(p => (p._id || p) === productId);
            if (isAdded) {
                message.success("Added to wishlist!");
            } else {
                message.info("Removed from wishlist.");
            }
        } catch (error) {
            console.error("❌ Toggle wishlist error:", error);
            message.error(error.message || "Failed to update wishlist.");
        }
    };

    const isInWishlist = (productId) => {
        return wishlist.products.some(p => (p._id || p) === productId);
    };

    const value = React.useMemo(() => ({
        wishlist,
        wishlistCount,
        loading,
        toggleWishlist,
        isInWishlist,
        refreshWishlist: fetchWishlist
    }), [
        wishlist,
        wishlistCount,
        loading,
        fetchWishlist
    ]);

    return <WishlistContext.Provider value={value}>{children}</WishlistContext.Provider>;
};
export const useWishlist = () => useContext(WishlistContext);
